import { render, staticRenderFns } from "./ClickCollectOrders.vue?vue&type=template&id=1a3ab39e&"
import script from "./ClickCollectOrders.vue?vue&type=script&lang=js&"
export * from "./ClickCollectOrders.vue?vue&type=script&lang=js&"
import style0 from "./ClickCollectOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports